<div class="attack-modifiers-fullscreen">
  <div class="header">
    <div class="title">
      @if (!!character) {
      <img class="icon" [src]="character.iconUrl" />
      {{gameManager.characterManager.characterName(character, true)}}
      &nbsp;
      }

      @if (!character && !townGuard) {
      @if (numeration == 'm') {
      <img class="icon" src="./assets/images/monster/enemy.png" />
      }
      @if (numeration == 'm') {
      <span><span [ghs-label]="'monster'"></span>&nbsp;</span>
      }
      @if (numeration == 'A') {
      <span><span [ghs-label]="'game.ally'"></span>&nbsp;</span>
      }
      }
      @if (!townGuard) {
      <span [ghs-label]="'game.attackModifiers'"></span>
      }
      @if (townGuard) {
      <span [ghs-label]="'party.campaign.townGuardDeck'"></span>
      }
      @if (!character && numeration != 'm' && numeration != 'A') {
      <span>&nbsp;{{numeration}}</span>
      }
    </div>
  </div>
  <div class="attack-modifierdeck-container" [ngClass]="{'vertical'  : vertical()}">
    <ghs-attackmodifier-deck [deck]="deck" [character]="character" [ally]="ally" [numeration]="numeration"
      [fullscreen]="false" [vertical]="vertical()" [townGuard]="townGuard" [initTimeout]="1"
      (before)="beforeAttackModifierDeck($event)" (after)="afterAttackModifierDeck($event)">
    </ghs-attackmodifier-deck>
    <div class="close-container" (click)="close()"></div>
  </div>
  <div class="close-container" (click)="close()"></div>
</div>